import { render, staticRenderFns } from "./Audios.vue?vue&type=template&id=6bf1a26f&scoped=true"
import script from "./Audios.vue?vue&type=script&lang=js"
export * from "./Audios.vue?vue&type=script&lang=js"
import style0 from "./Audios.vue?vue&type=style&index=0&id=6bf1a26f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf1a26f",
  null
  
)

export default component.exports